import { BaseFormLabel } from '../BaseFormLabel/BaseFormLabel';
// import css from '../../FormWrapper/FormWrapper.module.scss';
import css from './RadioFormLabel.module.scss';
import { RadioFormLabelProps } from './RadioFormLabel.types';

/**
 * The form label for the `Radio` control with styling and
 * component type that is specific for the Radio implementations.
 *
 * @note This control does not actually provide a `label` for the `Radio` control
 * but rather a `legend` which acts as a caption for the entire group of `Radio`
 * controls.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend#technical_summary
 *
 * @param id - {@link RadioFormLabelProps.id id} description.
 * @param label - {@link RadioFormLabelProps.label label} description.
 */
const RadioFormLabel = ({
    id,
    label,
}: RadioFormLabelProps) => {
    return (
        <BaseFormLabel
            id={id}
            classes={{
                root: css.label,
                focused: css.focused,
                error: css.error,
            }}
            componentType={'legend'}
        >
            {label}
        </BaseFormLabel>
    );
};

export default RadioFormLabel;